import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t border-gray-200 mt-10" data-id="element-21">
      <div className="container mx-auto px-4 py-8" data-id="element-22">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-23">
          {/* Company Info */}
          <div data-id="element-24">
            <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-25">
              EcoTech Market
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-26">
              Your trusted marketplace for quality used electronics and precious
              metals.
            </p>
            <div className="flex space-x-4" data-id="element-27">
              <a href="#" className="text-gray-400 hover:text-green-600" data-id="element-28">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-29">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-30" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-green-600" data-id="element-31">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-32">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723 10.053 10.053 0 01-3.127 1.184 4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.937 4.937 0 004.604 3.417 9.868 9.868 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63a9.936 9.936 0 002.46-2.548l-.047-.02z" data-id="element-33" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-green-600" data-id="element-34">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-35">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm4.441 16.892c-2.102.144-6.784.144-8.883 0C5.282 16.736 5.017 15.622 5 12c.017-3.629.285-4.736 2.558-4.892 2.099-.144 6.782-.144 8.883 0C18.718 7.264 18.982 8.378 19 12c-.018 3.629-.285 4.736-2.559 4.892zM10 9.658l4.917 2.338L10 14.342V9.658z" data-id="element-36" />
                </svg>
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-37">
            <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-38">
              Quick Links
            </h3>
            <ul className="space-y-2" data-id="element-39">
              <li data-id="element-40">
                <a href="#" className="text-gray-600 hover:text-green-600 transition" data-id="element-41">
                  About Us
                </a>
              </li>
              <li data-id="element-42">
                <a href="#" className="text-gray-600 hover:text-green-600 transition" data-id="element-43">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-44">
                <a href="#" className="text-gray-600 hover:text-green-600 transition" data-id="element-45">
                  Terms & Conditions
                </a>
              </li>
              <li data-id="element-46">
                <a href="#" className="text-gray-600 hover:text-green-600 transition" data-id="element-47">
                  FAQs
                </a>
              </li>
              <li data-id="element-48">
                <a href="#" className="text-gray-600 hover:text-green-600 transition" data-id="element-49">
                  Shipping Information
                </a>
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div data-id="element-50">
            <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-51">
              Contact Us
            </h3>
            <ul className="space-y-3" data-id="element-52">
              <li className="flex items-start" data-id="element-53">
                <MapPinIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5" data-id="element-54" />
                <span className="text-gray-600" data-id="element-55">
                  123 Market Street, San Francisco, CA 94103
                </span>
              </li>
              <li className="flex items-center" data-id="element-56">
                <PhoneIcon className="h-5 w-5 text-green-600 mr-2" data-id="element-57" />
                <a href="tel:+15551234567" className="text-gray-600 hover:text-green-600 transition" data-id="element-58">
                  (555) 123-4567
                </a>
              </li>
              <li className="flex items-center" data-id="element-59">
                <MailIcon className="h-5 w-5 text-green-600 mr-2" data-id="element-60" />
                <a href="mailto:info@ecotechmarket.com" className="text-gray-600 hover:text-green-600 transition" data-id="element-61">
                  info@ecotechmarket.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 mt-8 pt-6 text-center text-gray-500 text-sm" data-id="element-62">
          <p data-id="element-63">
            &copy; {new Date().getFullYear()} EcoTech Market. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}